var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 600",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(754 337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6 3.3C5.7 5.4 0.2 4.2 -1.7 1.6C-3.6 -1 -1.8 -5.1 1 -4.6C3.8 -4 7.5 1.3 6.6 3.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(544 529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8 1.7C1.7 3.5 -2.5 3.7 -3.4 2C-4.4 0.3 -2.2 -3.3 -0.1 -3.3C1.9 -3.4 3.9 0 2.8 1.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(602 490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4 0.3C0.3 0.5 -0.3 0.5 -0.4 0.3C-0.6 0.2 -0.3 -0.2 0 -0.2C0.3 -0.2 0.6 0.2 0.4 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168 281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9 2.7C3 3.8 -1.2 3.5 -2.4 2.2C-3.6 0.9 -1.8 -1.3 0.3 -1.2C2.4 -1 4.8 1.6 3.9 2.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168 325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9 0.7C0.6 1.2 -0.8 1.2 -1.1 0.8C-1.5 0.4 -0.7 -0.4 0 -0.5C0.7 -0.5 1.3 0.3 0.9 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(275 268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4 -0.1C1 1.4 -0.5 1.3 -1 -0.2C-1.4 -1.8 -0.7 -4.7 0.1 -4.7C0.9 -4.6 1.7 -1.6 1.4 -0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(512 384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3C2.1 4.4 -3.2 4.7 -4.4 3.4C-5.6 2.1 -2.8 -0.8 -0.2 -0.9C2.4 -1 4.9 1.6 3.5 3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(816 584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1 0.5C0.8 1.1 -0.4 1.1 -0.8 0.4C-1.1 -0.2 -0.6 -1.4 0.1 -1.3C0.7 -1.3 1.4 0 1.1 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(152 388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.1 0.2C0 0.3 -0.4 0.4 -0.5 0.3C-0.5 0.2 -0.3 0 -0.1 -0.1C0.1 -0.1 0.3 0.1 0.1 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(481 331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8 0.6C0.5 1 -0.6 1 -0.8 0.6C-1.1 0.2 -0.6 -0.5 0 -0.5C0.5 -0.5 1.1 0.2 0.8 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(521 318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 1.6C1.7 3.9 -3 4.2 -4.1 1.9C-5.1 -0.3 -2.6 -5 -0.2 -5.2C2.1 -5.3 4.2 -0.8 3 1.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204 548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6 1C-0.6 2.3 -3.7 3.2 -4.2 2.2C-4.6 1.3 -2.3 -1.5 -0.7 -1.9C0.9 -2.3 1.7 -0.4 0.6 1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(265 186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9 0C0.6 0.9 -0.3 0.8 -0.6 -0.1C-0.8 -1.1 -0.4 -2.9 0.1 -2.9C0.5 -2.8 1.1 -1 0.9 0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(748 454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6 1.7C1.6 3.2 -2.1 3.3 -3 1.9C-3.9 0.5 -1.9 -2.4 -0.1 -2.4C1.8 -2.5 3.6 0.3 2.6 1.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(674 436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9 0.3C0.7 0.7 0 0.6 -0.3 0.1C-0.5 -0.4 -0.3 -1.2 0.1 -1.1C0.5 -1.1 1 -0.1 0.9 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.2 0.6C1.4 2.6 -1.7 2.7 -2.5 0.7C-3.2 -1.2 -1.6 -5.3 -0.1 -5.3C1.5 -5.3 3 -1.4 2.2 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(184 116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3 1.3C0.3 2.4 -2.7 2.8 -3.3 2C-3.8 1.1 -1.9 -1.1 -0.4 -1.3C1.1 -1.5 2.2 0.2 1.3 1.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378 391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8 2C3.5 2.7 0.9 1.9 -0.1 0.7C-1.2 -0.4 -0.6 -1.8 0.7 -1.4C2.1 -1 4.1 1.3 3.8 2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682 268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9 0.6C0.3 1.6 -1.8 1.9 -2.2 1C-2.5 0.2 -1.3 -1.9 -0.3 -2C0.8 -2.2 1.5 -0.4 0.9 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(275 329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1.6C2 2.2 -0.3 1.8 -1 1.1C-1.7 0.5 -0.9 -0.6 0.3 -0.4C1.4 -0.2 2.9 1.1 2.5 1.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109 366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.9 2.2C1.9 3.3 -2 3.3 -2.9 2.2C-3.9 1.1 -1.9 -1.1 0 -1.1C1.9 -1.1 3.8 1.1 2.9 2.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(167 22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.1 0C-0.1 0.4 -0.6 0.5 -0.7 0.2C-0.7 -0.1 -0.4 -0.8 -0.1 -0.8C0.2 -0.9 0.3 -0.3 0.1 0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(269 222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0.4C0.4 2.8 -3.1 3.3 -3.8 1.2C-4.4 -1 -2.2 -5.8 -0.4 -6C1.3 -6.3 2.7 -2 1.5 0.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9 2C0.4 3.8 -4.5 4.6 -5.4 3.2C-6.2 1.8 -3.1 -1.7 -0.7 -2.1C1.7 -2.5 3.5 0.3 1.9 2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(895 385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 2.5C2.7 4.6 -2.5 4.5 -3.9 2.4C-5.2 0.3 -2.6 -3.9 0 -3.9C2.7 -3.9 5.3 0.4 4 2.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(278 475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6 0.6C0.1 1.1 -1.4 1.4 -1.6 1C-1.9 0.5 -0.9 -0.6 -0.2 -0.7C0.5 -0.8 1 0 0.6 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(774 252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 1.3C3.2 3.5 -0.5 3 -1.7 0.6C-2.9 -1.9 -1.4 -6.2 0.5 -6C2.3 -5.7 4.7 -0.8 4 1.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(806 488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7 1.4C0.5 2.9 -3.1 3.4 -3.8 2.1C-4.5 0.9 -2.2 -2.1 -0.4 -2.4C1.4 -2.6 2.8 -0.1 1.7 1.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(477 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0.5C0.8 1 -0.2 0.8 -0.5 0.4C-0.8 -0.1 -0.4 -1 0.1 -0.9C0.6 -0.8 1.2 0.1 1 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(486 424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3 0.5C1.1 1.1 0 0.9 -0.4 0.2C-0.8 -0.5 -0.4 -1.7 0.2 -1.6C0.7 -1.5 1.5 -0.1 1.3 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(338 353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3 0.8C1 1.2 -0.3 1.1 -0.7 0.6C-1.1 0 -0.6 -0.9 0.1 -0.9C0.8 -0.8 1.6 0.3 1.3 0.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104 334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6 -0.1C-0.2 1.7 -2.4 2.2 -2.7 0.7C-3.1 -0.9 -1.5 -4.4 -0.4 -4.6C0.7 -4.9 1.4 -1.8 0.6 -0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(259 587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.1 0.3C-0.3 0.7 -1.2 0.9 -1.3 0.7C-1.4 0.5 -0.7 -0.1 -0.2 -0.3C0.2 -0.4 0.4 0 0.1 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(330 111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3 1C2.9 2.6 0.2 2 -0.7 0.1C-1.6 -1.8 -0.8 -4.9 0.5 -4.6C1.8 -4.3 3.7 -0.6 3.3 1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(329 150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.3C0.3 0.5 -0.3 0.5 -0.5 0.3C-0.6 0.1 -0.3 -0.4 0 -0.4C0.3 -0.4 0.6 0.1 0.5 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(637 503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7 0.2C-0.3 2.2 -3.3 2.9 -3.7 1.3C-4.1 -0.4 -2.1 -4.4 -0.6 -4.7C0.9 -5.1 1.8 -1.8 0.7 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(517 586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7 1.9C0.3 3.4 -4.1 4.1 -4.9 3C-5.6 1.8 -2.8 -1.2 -0.6 -1.6C1.6 -1.9 3.1 0.4 1.7 1.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(723 141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 1.7C2.9 2.7 0.2 2.1 -0.8 0.8C-1.8 -0.6 -0.9 -2.6 0.5 -2.3C1.9 -2 3.8 0.6 3.4 1.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465 217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1 0.5C0.7 1.3 -0.8 1.4 -1.2 0.5C-1.6 -0.3 -0.8 -2 0 -2C0.8 -2.1 1.5 -0.4 1.1 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(821 250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4 0.1C0.3 0.5 -0.3 0.5 -0.4 0.1C-0.5 -0.3 -0.3 -1 0 -1C0.3 -1 0.5 -0.3 0.4 0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(534 69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 1C2.5 2.5 -0.1 2.1 -1 0.3C-1.9 -1.4 -0.9 -4.4 0.4 -4.2C1.7 -3.9 3.4 -0.5 3 1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120 539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0.9C0.5 1.5 -1.2 1.6 -1.6 1.1C-2 0.5 -1 -0.7 -0.1 -0.7C0.8 -0.8 1.5 0.3 1 0.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(373 181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0C-0.1 0.2 -0.4 0.3 -0.4 0.1C-0.5 -0.1 -0.2 -0.5 -0.1 -0.6C0.1 -0.6 0.2 -0.2 0 0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(181 497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0.4C0.9 0.8 0.1 0.6 -0.2 0.1C-0.4 -0.4 -0.2 -1.2 0.2 -1.1C0.6 -1 1.1 0 1 0.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(471 171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4 2.4C4.8 4.2 0.5 3.2 -1 0.9C-2.5 -1.4 -1.2 -4.9 0.9 -4.3C3 -3.8 6 0.7 5.4 2.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(568 358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4 0C0.3 0.5 -0.2 0.4 -0.3 -0.1C-0.5 -0.6 -0.2 -1.5 0 -1.5C0.3 -1.5 0.6 -0.5 0.4 0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(707 405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6 2.1C2.5 3.9 -1.9 3.8 -3.1 1.9C-4.2 0 -2.1 -3.6 0.1 -3.5C2.3 -3.5 4.6 0.3 3.6 2.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65 573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.9 1.3C2.1 3.1 -1.4 2.9 -2.3 1.1C-3.2 -0.7 -1.6 -4.2 0.1 -4.1C1.8 -4 3.7 -0.4 2.9 1.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(721 53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2 1C-0.2 3.3 -4.5 4.2 -5.2 2.4C-5.9 0.6 -2.9 -3.9 -0.8 -4.4C1.4 -4.9 2.7 -1.3 1.2 1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0.3C0.8 0.9 -0.2 0.8 -0.5 0.1C-0.8 -0.5 -0.4 -1.8 0.1 -1.7C0.6 -1.6 1.2 -0.3 1 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280 387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7 0.7C-0.1 1.7 -2.3 2.1 -2.6 1.4C-3 0.6 -1.5 -1.5 -0.4 -1.7C0.7 -1.9 1.4 -0.3 0.7 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2 0.3C0.9 1.3 -0.6 1.3 -1 0.2C-1.4 -0.9 -0.7 -3 0 -3C0.8 -2.9 1.6 -0.8 1.2 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(670 176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9 0.5C0.7 0.9 -0.4 0.9 -0.7 0.4C-0.9 0 -0.5 -0.8 0 -0.7C0.6 -0.7 1.1 0.1 0.9 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(283 555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1 0.9C0.3 2.1 -2.3 2.5 -2.8 1.4C-3.3 0.4 -1.6 -2 -0.3 -2.2C1 -2.4 1.9 -0.3 1.1 0.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(592 26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5C0.1 1 -1.1 1.2 -1.3 0.7C-1.6 0.3 -0.8 -0.8 -0.2 -0.9C0.5 -1 0.9 -0.1 0.5 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(781 400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3 1.6C2 4.2 -2.9 4.3 -4.1 1.9C-5.2 -0.5 -2.6 -5.6 -0.2 -5.7C2.3 -5.8 4.6 -0.9 3.3 1.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(583 141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.2 0.1C0.1 0.3 -0.2 0.3 -0.3 0.1C-0.3 -0.1 -0.2 -0.5 0 -0.5C0.1 -0.5 0.3 -0.1 0.2 0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(123 169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.1C0.3 0.6 -0.5 0.7 -0.7 0.2C-0.8 -0.3 -0.4 -1.4 0 -1.4C0.4 -1.4 0.7 -0.4 0.5 0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(871 56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6 0.4C0.4 0.7 -0.4 0.7 -0.6 0.4C-0.8 0.1 -0.4 -0.4 0 -0.4C0.4 -0.4 0.8 0.1 0.6 0.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(322 291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8 0.7C1.6 1.3 0.3 1 -0.2 0.2C-0.7 -0.5 -0.3 -1.7 0.3 -1.5C1 -1.3 1.9 0.2 1.8 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(348 299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6 1.1C0.6 2.6 -2.6 2.9 -3.2 1.7C-3.8 0.4 -1.9 -2.5 -0.3 -2.7C1.3 -2.9 2.5 -0.4 1.6 1.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(844 360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9 0.7C0.6 0.9 -0.4 0.9 -0.7 0.6C-1 0.3 -0.5 -0.2 0 -0.2C0.6 -0.2 1.1 0.4 0.9 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54 279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6 0.4C0.4 0.7 -0.5 0.8 -0.7 0.4C-0.9 0 -0.5 -0.7 0 -0.7C0.4 -0.7 0.8 0 0.6 0.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(146 53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6 0.4C0.3 0.7 -0.5 0.8 -0.7 0.4C-0.9 0.1 -0.5 -0.6 0 -0.6C0.4 -0.6 0.8 0 0.6 0.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(636 374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1.2C1 4.1 -4 4.6 -5 2.1C-6 -0.4 -3 -6 -0.5 -6.3C2 -6.6 4 -1.6 2.5 1.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(395 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.1 2.6C3.3 3.8 -0.8 3.3 -2 1.9C-3.2 0.4 -1.6 -1.9 0.4 -1.7C2.5 -1.4 4.9 1.4 4.1 2.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75 432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4 0.3C0.2 0.6 -0.5 0.7 -0.7 0.4C-0.9 0.1 -0.4 -0.6 -0.1 -0.7C0.3 -0.7 0.6 -0.1 0.4 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(566 299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3 3.9C3.8 5.7 -2.7 5.5 -4.4 3.6C-6.1 1.7 -3 -1.9 0.2 -1.7C3.4 -1.6 6.9 2.1 5.3 3.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177 54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1 0.5C0.9 1 -0.2 0.9 -0.6 0.3C-0.9 -0.2 -0.5 -1.3 0.1 -1.2C0.7 -1.2 1.3 0 1.1 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(623 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4 0.9C1.2 1.1 0 0.9 -0.4 0.5C-0.7 0.2 -0.4 -0.3 0.2 -0.2C0.8 -0.1 1.6 0.7 1.4 0.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(523 268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0.8C0.8 2.2 -1.9 2.4 -2.5 1.2C-3.1 -0.1 -1.5 -2.8 -0.2 -2.9C1.1 -3 2.3 -0.5 1.5 0.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(705 349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9 1C1.6 1.5 0.1 1.1 -0.4 0.5C-0.9 -0.2 -0.5 -1.2 0.3 -1C1 -0.8 2.1 0.5 1.9 1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(206 184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.1 1.1C2.8 2.5 0.2 1.9 -0.6 0.2C-1.5 -1.4 -0.8 -4.2 0.5 -3.9C1.8 -3.6 3.5 -0.3 3.1 1.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(251 542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2 1.6C2.8 2.5 0.2 2 -0.7 0.7C-1.6 -0.5 -0.8 -2.4 0.5 -2.1C1.8 -1.8 3.6 0.6 3.2 1.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1 0.8C0.7 1.3 -0.8 1.3 -1.2 0.8C-1.5 0.4 -0.8 -0.6 0 -0.6C0.7 -0.6 1.5 0.3 1.1 0.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(265 26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8 1.3C1.2 2 -1 1.9 -1.6 1.2C-2.2 0.5 -1.1 -0.9 0 -0.9C1.2 -0.9 2.3 0.6 1.8 1.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(391 146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4 0.3C-0.1 0.9 -1.3 1.2 -1.5 0.7C-1.7 0.2 -0.9 -1.1 -0.2 -1.3C0.4 -1.4 0.8 -0.4 0.4 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(302 313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8 0.6C0.5 0.8 -0.4 0.8 -0.6 0.5C-0.9 0.2 -0.4 -0.3 0 -0.3C0.5 -0.3 1 0.3 0.8 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(514 219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0.8C2.2 1.9 0.2 1.5 -0.5 0.1C-1.2 -1.3 -0.6 -3.6 0.4 -3.4C1.4 -3.2 2.8 -0.4 2.5 0.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(823 300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9 1.4C1.4 2 -0.9 1.9 -1.5 1.2C-2.1 0.6 -1 -0.6 0.1 -0.6C1.2 -0.5 2.4 0.8 1.9 1.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(870 503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8 0.6C0.6 0.9 -0.4 0.8 -0.6 0.6C-0.9 0.3 -0.4 -0.1 0 -0.1C0.5 -0.1 1 0.4 0.8 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(851 397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.7 2.4C2.5 4.2 -2.2 4.1 -3.5 2.3C-4.7 0.5 -2.3 -3 0.1 -3C2.4 -3 4.9 0.6 3.7 2.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(567 423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8 1.3C2.3 2.6 -0.5 2.2 -1.4 0.8C-2.2 -0.6 -1.1 -3.1 0.3 -3C1.7 -2.8 3.4 0.1 2.8 1.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(436 477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8 0.6C0.1 1.6 -1.9 1.9 -2.3 1.1C-2.7 0.2 -1.3 -1.8 -0.3 -2C0.7 -2.2 1.4 -0.5 0.8 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432 277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1.7C3.1 2.6 0.6 1.8 -0.4 0.6C-1.3 -0.6 -0.6 -2.4 0.6 -2C1.9 -1.7 3.8 0.8 3.5 1.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(570 568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0.8C1.1 1.6 -0.7 1.5 -1.2 0.7C-1.7 -0.1 -0.8 -1.7 0.1 -1.6C1 -1.6 1.9 0 1.5 0.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(633 593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1C-0.8 2.5 -4.3 3.5 -4.8 2.5C-5.2 1.5 -2.6 -1.6 -0.9 -2.1C0.9 -2.6 1.8 -0.5 0.5 1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(717 15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4 0.6C1.9 2.4 -0.7 2.1 -1.5 0.2C-2.2 -1.7 -1.1 -5.2 0.2 -5.1C1.5 -5 3 -1.2 2.4 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95 394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.1 0.1C0 0.2 -0.4 0.3 -0.4 0.2C-0.5 0 -0.2 -0.3 -0.1 -0.4C0.1 -0.4 0.2 -0.1 0.1 0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(308 530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8 0.6C0 1.9 -2.5 2.4 -2.9 1.3C-3.3 0.2 -1.7 -2.4 -0.4 -2.6C0.8 -2.8 1.6 -0.7 0.8 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(223 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8 1.6C1.7 3.6 -2.6 3.8 -3.6 1.9C-4.6 0 -2.3 -3.9 -0.1 -4C2 -4.1 4 -0.3 2.8 1.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204 75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7 1.4C1.2 2 -1.2 2 -1.7 1.4C-2.3 0.9 -1.2 -0.3 0 -0.3C1.2 -0.3 2.3 0.9 1.7 1.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(895 195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3 1.2C1.6 2.4 -1 2.3 -1.8 1C-2.5 -0.2 -1.2 -2.5 0.1 -2.4C1.4 -2.4 2.9 0.1 2.3 1.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(599 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3 0C0.2 0.4 -0.3 0.4 -0.4 0.1C-0.5 -0.3 -0.3 -1 0 -1.1C0.2 -1.1 0.5 -0.3 0.3 0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120 109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4 0.3C0.2 0.5 -0.3 0.5 -0.4 0.3C-0.6 0.1 -0.3 -0.4 0 -0.4C0.3 -0.4 0.5 0 0.4 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(644 157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.8 2.5C4.4 3.4 1.2 2.3 -0.1 0.9C-1.4 -0.6 -0.7 -2.3 0.9 -1.8C2.6 -1.2 5.1 1.6 4.8 2.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(697 77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3 3.2C4.7 4.2 0.4 3.2 -1.1 1.7C-2.6 0.2 -1.3 -1.9 0.8 -1.4C3 -0.9 6 2.1 5.3 3.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227 580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3 1.3C2.7 3.1 -0.7 2.7 -1.7 0.8C-2.7 -1.2 -1.4 -4.8 0.3 -4.6C2 -4.4 4 -0.5 3.3 1.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(290 54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1 0.6C0.4 1.9 -2 2.2 -2.4 1C-2.9 -0.1 -1.4 -2.7 -0.3 -2.8C0.9 -3 1.8 -0.7 1.1 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8 1.4C2.3 2.6 -0.5 2.2 -1.3 0.9C-2.2 -0.4 -1.1 -2.7 0.3 -2.5C1.7 -2.4 3.3 0.3 2.8 1.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(825 14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0.1C0.7 1.1 -0.5 1.1 -0.9 0.1C-1.2 -1 -0.6 -2.9 0 -2.9C0.7 -2.9 1.3 -0.9 1 0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(626 464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3 0.2C0.3 0.3 0 0.2 -0.1 0.1C-0.2 0 -0.1 -0.2 0.1 -0.2C0.2 -0.2 0.4 0.1 0.3 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(156 589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7 0.7C0 1.7 -2.3 2.2 -2.6 1.4C-3 0.6 -1.5 -1.5 -0.4 -1.7C0.7 -1.9 1.5 -0.3 0.7 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2 0.8C1 1 0 0.8 -0.4 0.5C-0.7 0.1 -0.4 -0.4 0.2 -0.3C0.7 -0.2 1.4 0.5 1.2 0.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(254 401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6 0.6C-0.2 1.8 -2.5 2.3 -2.9 1.4C-3.3 0.4 -1.6 -2 -0.5 -2.2C0.7 -2.5 1.5 -0.6 0.6 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360 147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.1 1.2C1.3 2.5 -1.7 2.6 -2.4 1.4C-3.1 0.1 -1.6 -2.5 -0.1 -2.5C1.4 -2.6 2.8 -0.1 2.1 1.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792 159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8 0.6C0.3 1.4 -1.5 1.7 -1.9 0.9C-2.2 0.2 -1.1 -1.5 -0.2 -1.6C0.7 -1.8 1.4 -0.3 0.8 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(703 443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7 1.5C1.9 2.8 -1.3 2.7 -2.1 1.3C-3 0 -1.5 -2.6 0.1 -2.6C1.7 -2.5 3.4 0.2 2.7 1.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(572 102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4 0.4C0.1 0.8 -0.9 0.9 -1 0.6C-1.2 0.4 -0.6 -0.4 -0.1 -0.4C0.4 -0.5 0.7 0.1 0.4 0.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832 59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0.6C1.3 2.5 -1.7 2.6 -2.4 0.7C-3.1 -1.2 -1.5 -5 -0.1 -5C1.4 -5.1 2.8 -1.3 2 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(896 551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2 0C0.8 1.3 -0.8 1.3 -1.1 0C-1.5 -1.3 -0.8 -3.9 0 -3.9C0.8 -3.9 1.6 -1.3 1.2 0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(409 323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9 0.5C1.1 2.5 -1.9 2.7 -2.6 0.7C-3.3 -1.3 -1.6 -5.3 -0.1 -5.4C1.3 -5.5 2.7 -1.6 1.9 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672 107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.9 1.5C1.8 3.4 -2.2 3.5 -3.1 1.6C-4.1 -0.3 -2.1 -4.1 -0.1 -4.1C1.9 -4.1 3.9 -0.4 2.9 1.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268 76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3 0.2C0.2 0.4 -0.2 0.4 -0.3 0.2C-0.4 0 -0.2 -0.3 0 -0.3C0.2 -0.3 0.4 0 0.3 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(629 124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7 1.1C2 2.7 -1.1 2.6 -1.9 0.8C-2.8 -0.9 -1.4 -4.2 0.1 -4.1C1.7 -4 3.3 -0.6 2.7 1.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(793 438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3 0.5C0.6 2.1 -2 2.4 -2.5 0.9C-3.1 -0.6 -1.5 -3.9 -0.2 -4C1 -4.2 2.1 -1.2 1.3 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(554 18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6 0.3C0.4 0.8 -0.6 0.8 -0.8 0.4C-1 -0.1 -0.5 -1 0 -1C0.4 -1 0.9 -0.1 0.6 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(644 534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.1C1.3 3.4 -2.8 3.7 -3.7 2.5C-4.6 1.3 -2.3 -1.4 -0.2 -1.6C1.8 -1.7 3.7 0.7 2.5 2.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(598 406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9 0.4C0.7 0.9 -0.3 0.8 -0.5 0.3C-0.8 -0.2 -0.4 -1 0.1 -1C0.5 -1 1.1 0 0.9 0.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(411 247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9 1.3C1.3 2.3 -1.5 2.4 -2.1 1.4C-2.8 0.4 -1.4 -1.6 0 -1.6C1.3 -1.7 2.6 0.3 1.9 1.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227 332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 1C2.6 2.5 0.1 1.9 -0.7 0.2C-1.6 -1.5 -0.8 -4.5 0.5 -4.2C1.7 -3.9 3.4 -0.5 3 1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(98 501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1 0.7C0.6 1.4 -1.1 1.5 -1.5 0.8C-1.9 0.1 -0.9 -1.4 -0.1 -1.5C0.8 -1.5 1.5 -0.1 1.1 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(572 388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.7 2.9C2.2 4.7 -3.4 5 -4.7 3.3C-6 1.6 -3 -2 -0.2 -2.1C2.6 -2.2 5.2 1.2 3.7 2.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(586 525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6 0.1C0.4 0.8 -0.5 0.8 -0.8 0.1C-1 -0.6 -0.5 -2 0 -2C0.4 -2.1 0.9 -0.6 0.6 0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(838 529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.2 0C0 0.4 -0.6 0.5 -0.7 0.2C-0.7 -0.1 -0.4 -0.9 -0.1 -0.9C0.2 -1 0.4 -0.3 0.2 0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49 206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0.3C0.3 1.7 -1.8 1.9 -2.2 0.7C-2.6 -0.6 -1.3 -3.3 -0.2 -3.5C0.8 -3.6 1.6 -1.1 1 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(598 586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7 0.2C0.4 0.8 -0.5 0.8 -0.7 0.2C-0.9 -0.3 -0.4 -1.4 0 -1.4C0.4 -1.4 0.9 -0.3 0.7 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(151 471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3 0.7C0.7 1.9 -1.6 2 -2.1 0.9C-2.5 -0.1 -1.3 -2.5 -0.2 -2.6C1 -2.6 1.9 -0.5 1.3 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(421 119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3 0C-0.7 1.9 -3.3 2.7 -3.7 1.2C-4 -0.3 -2 -4.1 -0.7 -4.5C0.7 -4.9 1.3 -1.9 0.3 0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4 1.2C2.1 1.9 0.2 1.5 -0.5 0.5C-1.2 -0.4 -0.6 -1.9 0.4 -1.7C1.4 -1.5 2.7 0.5 2.4 1.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(414 411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4 0.2C0.2 0.5 -0.4 0.5 -0.5 0.3C-0.7 0 -0.3 -0.6 0 -0.6C0.3 -0.7 0.5 -0.1 0.4 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242 246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2 0.6C1.1 1 0 0.8 -0.3 0.2C-0.7 -0.3 -0.3 -1.1 0.2 -1C0.7 -0.9 1.4 0.1 1.2 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(597 453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3 0C0 0.7 -0.8 0.8 -0.9 0.2C-1.1 -0.3 -0.5 -1.6 -0.1 -1.7C0.3 -1.8 0.6 -0.6 0.3 0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(643 189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.1C3.1 2.7 0.3 2.1 -0.7 1.2C-1.6 0.2 -0.8 -0.9 0.6 -0.6C1.9 -0.3 3.9 1.5 3.5 2.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(421 550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6 0.2C0.5 0.6 -0.1 0.5 -0.3 0.1C-0.5 -0.4 -0.2 -1.1 0.1 -1.1C0.4 -1.1 0.8 -0.2 0.6 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(342 552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.7 2.5C2.5 4.1 -2.1 4 -3.3 2.4C-4.5 0.8 -2.3 -2.3 0.1 -2.3C2.4 -2.3 4.8 1 3.7 2.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109 442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8 0.7C1.5 1.6 -0.3 1.4 -0.8 0.3C-1.3 -0.8 -0.7 -2.7 0.2 -2.6C1.1 -2.5 2.2 -0.3 1.8 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(707 249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.2 0.1C0.1 0.3 -0.3 0.4 -0.4 0.2C-0.5 0 -0.2 -0.3 0 -0.3C0.1 -0.4 0.3 -0.1 0.2 0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(446 182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.3C0.4 0.5 -0.2 0.5 -0.4 0.3C-0.6 0 -0.3 -0.4 0 -0.4C0.3 -0.4 0.7 0.1 0.5 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(601 371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6 1.2C1 2.1 -1.5 2.2 -2.1 1.4C-2.7 0.6 -1.4 -1.1 -0.1 -1.2C1.2 -1.3 2.3 0.4 1.6 1.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(407 441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 2.7C2.1 4.1 -2.7 4.2 -3.8 2.9C-5 1.6 -2.5 -1.2 -0.1 -1.3C2.3 -1.3 4.6 1.4 3.4 2.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(887 129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6 1.7C1.8 2.8 -1.4 2.7 -2.2 1.6C-3 0.4 -1.5 -1.8 0.1 -1.7C1.7 -1.7 3.4 0.6 2.6 1.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(354 577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 1.5C1.5 2.2 -1 2.1 -1.6 1.4C-2.3 0.6 -1.2 -0.7 0.1 -0.7C1.3 -0.6 2.6 0.8 2 1.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(611 199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0.2C1.5 2.1 -0.8 1.9 -1.4 0C-2.1 -2 -1 -5.8 0.1 -5.7C1.3 -5.7 2.5 -1.7 2 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(877 477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8 0.2C0.6 0.7 -0.1 0.6 -0.4 0.1C-0.6 -0.4 -0.3 -1.4 0.1 -1.4C0.5 -1.3 0.9 -0.3 0.8 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(202 247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3 0.3C-0.2 1.1 -1.7 1.5 -1.9 0.9C-2.2 0.3 -1.1 -1.3 -0.3 -1.5C0.4 -1.7 0.8 -0.5 0.3 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(701 321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7 1.2C-0.8 2.9 -4.8 4 -5.4 2.8C-5.9 1.6 -3 -2 -0.9 -2.5C1.1 -3.1 2.1 -0.6 0.7 1.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(680 299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 -0.1C0.6 1.3 -0.9 1.4 -1.3 0C-1.7 -1.5 -0.8 -4.4 -0.1 -4.4C0.7 -4.5 1.5 -1.6 1 -0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(555 206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 2.5C1.9 4.6 -3.6 4.9 -4.9 3C-6.1 1 -3.1 -3.3 -0.3 -3.4C2.5 -3.6 4.9 0.3 3.4 2.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(898 84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7 1C1.2 1.8 -0.9 1.8 -1.4 1C-2 0.1 -1 -1.5 0 -1.4C1.1 -1.4 2.2 0.2 1.7 1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67 504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4 1.6C1.2 3.3 -2.8 3.6 -3.6 2C-4.5 0.4 -2.3 -3.1 -0.3 -3.3C1.8 -3.4 3.5 -0.2 2.4 1.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(457 243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4 0.5C1.9 2.4 -0.8 2.2 -1.5 0.2C-2.3 -1.8 -1.1 -5.5 0.2 -5.4C1.5 -5.3 3 -1.4 2.4 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55 369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.4 2.5C3.1 5 -2.6 4.9 -4.1 2.4C-5.5 -0.1 -2.8 -4.9 0.1 -4.9C2.9 -4.9 5.8 0.1 4.4 2.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(877 267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.2 3.9C3.7 5.7 -2.7 5.5 -4.4 3.6C-6.1 1.7 -3.1 -1.9 0.2 -1.8C3.4 -1.7 6.8 2.1 5.2 3.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(747 382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8 1.3C2.2 2.8 -0.9 2.5 -1.8 0.9C-2.6 -0.7 -1.3 -3.7 0.2 -3.6C1.8 -3.5 3.5 -0.2 2.8 1.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35 85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0.7C0.1 2 -2.5 2.5 -3 1.4C-3.4 0.3 -1.7 -2.3 -0.4 -2.5C0.9 -2.7 1.8 -0.6 1 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(381 98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4 3.2C4.1 5.3 -1.7 4.8 -3.4 2.5C-5 0.2 -2.5 -4 0.4 -3.8C3.3 -3.5 6.6 1.1 5.4 3.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(750 167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2 2.5C3.8 3.2 0.6 2.4 -0.6 1.2C-1.8 0 -0.9 -1.5 0.7 -1C2.3 -0.6 4.7 1.7 4.2 2.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120 569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.2 0.1C0.1 0.3 -0.2 0.3 -0.3 0.1C-0.4 0 -0.2 -0.4 0 -0.4C0.2 -0.4 0.3 -0.1 0.2 0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(327 495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6 0.6C-0.1 1.7 -2.3 2.1 -2.7 1.3C-3 0.5 -1.5 -1.6 -0.4 -1.9C0.7 -2.1 1.4 -0.5 0.6 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(434 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.2 -0.1C0.1 0.3 -0.2 0.3 -0.3 0C-0.4 -0.4 -0.2 -1.1 0 -1.1C0.1 -1.1 0.3 -0.4 0.2 -0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4 0.4C0.1 0.8 -0.9 1 -1.1 0.6C-1.3 0.3 -0.7 -0.6 -0.1 -0.7C0.4 -0.7 0.7 -0.1 0.4 0.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(821 168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1.7C1 3.9 -3.8 4.5 -4.8 2.5C-5.8 0.6 -2.9 -3.8 -0.5 -4.1C2 -4.3 3.9 -0.5 2.5 1.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(740 510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2 1.7C2.6 2.9 -0.5 2.5 -1.5 1.1C-2.5 -0.4 -1.2 -2.9 0.4 -2.7C1.9 -2.5 3.9 0.4 3.2 1.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(303 185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2 1.1C0.5 2.1 -2.1 2.4 -2.6 1.5C-3.1 0.7 -1.6 -1.4 -0.3 -1.5C1 -1.7 2 0 1.2 1.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(883 220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6 0.8C0.7 2.6 -2.5 3 -3.2 1.3C-3.8 -0.3 -1.9 -3.9 -0.3 -4C1.3 -4.2 2.6 -1 1.6 0.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0.6C2 2.3 -0.5 2.1 -1.3 0.2C-2 -1.7 -1 -5.2 0.3 -5C1.5 -4.9 3 -1.1 2.5 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6 1.6C2.1 2.5 -0.7 2.3 -1.5 1.3C-2.3 0.2 -1.2 -1.5 0.2 -1.4C1.6 -1.2 3.2 0.8 2.6 1.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780 514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4 0.2C0.3 0.4 -0.1 0.4 -0.3 0.1C-0.4 -0.1 -0.2 -0.5 0 -0.5C0.3 -0.4 0.5 0 0.4 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448 442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4 0.8C2.2 1.7 0.5 1.2 -0.1 0.1C-0.8 -1.1 -0.4 -2.8 0.5 -2.5C1.3 -2.2 2.6 0 2.4 0.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(401 503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.4 2.3C3.5 4 -0.8 3.5 -2.1 1.5C-3.4 -0.4 -1.7 -3.8 0.5 -3.6C2.6 -3.3 5.2 0.6 4.4 2.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(292 432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8 1.5C2.2 2.7 -0.8 2.5 -1.7 1.1C-2.5 -0.3 -1.3 -2.7 0.2 -2.6C1.7 -2.4 3.5 0.3 2.8 1.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(751 283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4 1C0.7 2 -1.7 2.2 -2.2 1.3C-2.7 0.4 -1.3 -1.5 -0.2 -1.6C1 -1.7 2.1 0 1.4 1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(609 162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.9 1.4C2.4 2.6 -0.4 2.2 -1.3 0.8C-2.1 -0.7 -1.1 -3.2 0.3 -3.1C1.7 -2.9 3.5 0.1 2.9 1.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(450 515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7 1C1.3 1.7 -0.6 1.5 -1.1 0.8C-1.6 0.1 -0.8 -1.2 0.1 -1.2C1 -1.1 2.1 0.3 1.7 1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(510 559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9 0.2C0.7 0.8 -0.1 0.6 -0.3 0.1C-0.6 -0.5 -0.3 -1.6 0.1 -1.5C0.5 -1.5 1 -0.3 0.9 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357 476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7 0.5C1.5 1.5 0 1.2 -0.5 0.1C-1 -1 -0.5 -2.9 0.2 -2.8C1 -2.7 2 -0.5 1.7 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19 597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.4C-0.5 1.9 -3.2 2.7 -3.5 1.5C-3.9 0.4 -1.9 -2.7 -0.6 -3C0.7 -3.4 1.4 -1.1 0.5 0.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(136 322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8 -0.1C0.1 1.7 -2 2 -2.4 0.4C-2.7 -1.2 -1.4 -4.7 -0.3 -4.9C0.8 -5.1 1.5 -1.9 0.8 -0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(369 333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.3C0.3 0.5 -0.2 0.4 -0.3 0.2C-0.5 0 -0.2 -0.3 0 -0.3C0.3 -0.3 0.6 0.1 0.5 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170 559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8 0.8C1.2 2.1 -1.2 2.1 -1.8 0.8C-2.4 -0.5 -1.2 -3 0 -3C1.2 -3 2.4 -0.5 1.8 0.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.2 0C0.1 0.2 -0.1 0.2 -0.2 0C-0.2 -0.2 -0.1 -0.6 0 -0.6C0.1 -0.6 0.2 -0.2 0.2 0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312 254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6 0.3C0.5 0.6 -0.2 0.6 -0.4 0.2C-0.6 -0.2 -0.3 -1 0 -1C0.4 -1 0.8 -0.1 0.6 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(784 115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8 0.6C0.6 0.9 -0.4 0.8 -0.7 0.5C-0.9 0.2 -0.5 -0.4 0 -0.4C0.5 -0.3 1 0.3 0.8 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(718 103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9 0.3C0.7 0.7 -0.1 0.6 -0.3 0.1C-0.6 -0.3 -0.3 -1.2 0.1 -1.1C0.5 -1 1 -0.1 0.9 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(501 19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.2C0.4 0.4 0.1 0.3 -0.1 0.1C-0.2 -0.2 -0.1 -0.5 0.1 -0.4C0.3 -0.4 0.5 0 0.5 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(334 196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0.2C0.9 1.9 -1.3 1.9 -1.8 0.3C-2.3 -1.3 -1.2 -4.5 -0.1 -4.6C1 -4.6 2.1 -1.4 1.5 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(669 145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3 1C1.6 2.4 -1 2.3 -1.8 0.8C-2.5 -0.6 -1.2 -3.4 0.1 -3.4C1.4 -3.3 2.9 -0.4 2.3 1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(778 596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.4C1.2 3.7 -3.2 4.1 -4.2 3C-5.1 1.9 -2.6 -0.6 -0.3 -0.8C1.9 -1 3.8 1.2 2.5 2.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(779 328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2 0.5C0.4 2 -2 2.3 -2.5 0.9C-3 -0.5 -1.5 -3.5 -0.3 -3.7C1 -3.8 2 -1.1 1.2 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103 241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0.3C0.9 0.9 0 0.7 -0.3 0.1C-0.6 -0.6 -0.3 -1.7 0.1 -1.6C0.6 -1.5 1.2 -0.2 1 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(663 213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.2 0.2C0.2 0.3 -0.2 0.3 -0.3 0.2C-0.4 0.1 -0.2 -0.1 0 -0.1C0.2 -0.1 0.3 0.1 0.2 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(815 546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2 0.7C1 1.2 -0.3 1 -0.7 0.5C-1 0 -0.5 -0.9 0.1 -0.9C0.7 -0.8 1.5 0.2 1.2 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 2C2.2 4 -2.5 4.1 -3.6 2C-4.8 0 -2.4 -4.2 0 -4.2C2.3 -4.2 4.6 -0.1 3.4 2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(491 139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3 1.7C2.3 3.8 -2.1 3.7 -3.2 1.7C-4.3 -0.3 -2.1 -4.4 0 -4.4C2.2 -4.4 4.4 -0.3 3.3 1.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120 292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4 0.6C-0.1 1.2 -1.7 1.6 -2 1.2C-2.2 0.8 -1.1 -0.4 -0.3 -0.5C0.5 -0.7 1 0.1 0.4 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66 405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8 0.4C0.5 0.9 -0.5 0.9 -0.8 0.4C-1 -0.1 -0.5 -1.1 0 -1.1C0.5 -1.1 1 -0.1 0.8 0.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3 0.7C0.6 1.9 -1.7 2.1 -2.2 1.1C-2.7 0 -1.4 -2.4 -0.2 -2.6C1 -2.7 2 -0.5 1.3 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304 9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5C-0.8 2.7 -4.5 3.7 -5 2C-5.5 0.3 -2.8 -4.1 -0.9 -4.6C1 -5.1 1.9 -1.7 0.5 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(498 354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6 0.5C-0.2 1.8 -2.6 2.3 -2.9 1.3C-3.3 0.3 -1.6 -2.2 -0.5 -2.5C0.7 -2.7 1.4 -0.8 0.6 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179 185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 2.4C2.7 4.6 -2.6 4.6 -4 2.4C-5.3 0.2 -2.6 -4.1 0 -4.1C2.7 -4.1 5.3 0.3 4 2.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(161 145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7 0.8C0.2 1.3 -1.4 1.5 -1.7 1.1C-2 0.8 -1 -0.1 -0.2 -0.2C0.6 -0.3 1.2 0.3 0.7 0.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(704 568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8 0.7C0.3 1.3 -1.2 1.4 -1.5 1C-1.9 0.5 -0.9 -0.6 -0.2 -0.7C0.6 -0.8 1.3 0.1 0.8 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(486 46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.9 1.7C1.6 3.8 -3 4.1 -4 2.1C-5 0 -2.5 -4.4 -0.2 -4.5C2.1 -4.6 4.1 -0.5 2.9 1.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(301 116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6 1.5C1.3 3.7 -3.1 4 -4.1 2.1C-5 0.1 -2.5 -4.1 -0.3 -4.3C1.9 -4.5 3.8 -0.6 2.6 1.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648 69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0.9C1 3 -2.7 3.3 -3.5 1.4C-4.2 -0.5 -2.1 -4.8 -0.3 -4.9C1.5 -5.1 3.1 -1.2 2 0.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100 9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4 1C0.6 2 -1.8 2.3 -2.4 1.4C-2.9 0.5 -1.4 -1.5 -0.2 -1.6C1 -1.7 2.1 0 1.4 1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130 249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.4C0 1.1 -1.4 1.4 -1.6 0.8C-1.9 0.3 -0.9 -1.1 -0.2 -1.2C0.5 -1.3 0.9 -0.3 0.5 0.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106 65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4 0.9C1 1.5 -0.7 1.4 -1.1 0.8C-1.6 0.2 -0.8 -0.9 0.1 -0.9C0.9 -0.9 1.8 0.3 1.4 0.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.6C4 3.4 0.6 2.5 -0.7 1.3C-1.9 0.1 -0.9 -1.4 0.8 -1C2.5 -0.6 4.9 1.9 4.5 2.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(854 94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.1 0.2C0 0.3 -0.4 0.4 -0.5 0.3C-0.6 0.2 -0.3 -0.1 -0.1 -0.1C0.1 -0.2 0.3 0 0.1 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352 70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3 0.4C-0.1 0.9 -1.4 1.2 -1.6 0.9C-1.8 0.5 -0.9 -0.5 -0.2 -0.7C0.4 -0.8 0.8 -0.1 0.3 0.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(517 472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4 0.2C0.3 0.3 -0.1 0.3 -0.2 0.1C-0.3 0 -0.1 -0.3 0 -0.3C0.2 -0.3 0.4 0.1 0.4 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(705 526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8 0.9C1.1 2.1 -1.3 2.2 -1.9 1C-2.5 -0.1 -1.3 -2.5 0 -2.5C1.2 -2.5 2.4 -0.2 1.8 0.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(609 545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7 0.9C1.4 1.5 -0.2 1.3 -0.7 0.6C-1.3 -0.1 -0.6 -1.3 0.2 -1.2C1 -1.1 2.1 0.4 1.7 0.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399 591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4 0.2C0.2 0.7 -0.7 0.8 -0.9 0.4C-1 -0.1 -0.5 -1.1 -0.1 -1.1C0.4 -1.2 0.7 -0.3 0.4 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(92 474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3 0.1C0 0.7 -0.9 0.9 -1 0.3C-1.2 -0.3 -0.6 -1.6 -0.1 -1.7C0.3 -1.7 0.6 -0.6 0.3 0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378 548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.1 1.2C2.6 2.7 -0.2 2.2 -1.2 0.5C-2.1 -1.3 -1 -4.3 0.4 -4.1C1.8 -3.9 3.6 -0.4 3.1 1.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(475 281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3 1.2C1.6 2.5 -1.3 2.4 -2 1.1C-2.7 -0.2 -1.4 -2.8 0.1 -2.8C1.5 -2.8 2.9 -0.1 2.3 1.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(579 250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.2C0.3 0.7 -0.6 0.7 -0.7 0.3C-0.9 -0.1 -0.5 -1 0 -1.1C0.4 -1.1 0.7 -0.2 0.5 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(98 155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.1 0.1C0 0.3 -0.3 0.3 -0.4 0.2C-0.5 0 -0.2 -0.4 -0.1 -0.5C0.1 -0.5 0.2 -0.2 0.1 0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(433 309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9 2.3C3.9 4.7 -1.3 4.3 -2.9 1.5C-4.4 -1.2 -2.2 -6.2 0.4 -5.9C3 -5.7 6 -0.2 4.9 2.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207 420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0.7C0.6 1.2 -0.7 1.2 -1.1 0.7C-1.4 0.2 -0.7 -0.8 0 -0.8C0.7 -0.8 1.3 0.2 1 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245 429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7 0.6C0.4 1 -0.8 1.1 -1 0.7C-1.3 0.3 -0.7 -0.5 -0.1 -0.5C0.5 -0.6 1 0.2 0.7 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(374 234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7 0.7C0.9 2.3 -1.8 2.5 -2.5 1C-3.1 -0.5 -1.5 -3.7 -0.1 -3.8C1.2 -3.9 2.5 -0.9 1.7 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(98 184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7 0.4C1.5 1.3 0.2 1 -0.3 -0.1C-0.7 -1.1 -0.4 -2.9 0.3 -2.7C1 -2.6 1.9 -0.5 1.7 0.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(330 405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 2.1C2.7 3.2 -0.7 2.8 -1.7 1.5C-2.7 0.3 -1.4 -1.7 0.3 -1.5C2.1 -1.3 4.1 1.1 3.4 2.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(254 291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4 0.4C-0.2 1.4 -2.1 1.8 -2.3 1.1C-2.6 0.4 -1.3 -1.4 -0.4 -1.6C0.5 -1.8 1.1 -0.5 0.4 0.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(766 486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7 0.8C0.2 1.4 -1.6 1.7 -1.9 1.2C-2.2 0.7 -1.1 -0.5 -0.2 -0.6C0.7 -0.8 1.3 0.2 0.7 0.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832 450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 1.7C2.4 2.7 -0.5 2.4 -1.4 1.2C-2.3 0 -1.2 -2 0.3 -1.9C1.8 -1.7 3.6 0.7 3 1.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125 403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3 2.9C2.9 5 -2.8 5 -4.3 2.9C-5.7 0.9 -2.9 -3.1 0 -3.1C2.9 -3.1 5.7 0.9 4.3 2.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(714 470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.1 0.1C0 0.2 -0.2 0.2 -0.3 0.1C-0.3 0.1 -0.2 -0.1 0 -0.2C0.1 -0.2 0.2 0 0.1 0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(632 327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7 1.3C2.4 2 0.5 1.4 -0.3 0.4C-1 -0.6 -0.5 -2 0.5 -1.7C1.5 -1.4 2.9 0.6 2.7 1.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552 46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 -0.1C0.5 1.4 -1.3 1.6 -1.7 0.1C-2 -1.4 -1 -4.6 -0.1 -4.7C0.7 -4.7 1.5 -1.7 1 -0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(412 85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.2 0.9C1.4 2.6 -1.7 2.7 -2.4 1C-3.2 -0.7 -1.6 -4.1 0 -4.1C1.5 -4.2 3 -0.8 2.2 0.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260 365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 1.7C2.7 2.4 0.2 1.8 -0.6 0.9C-1.5 -0.1 -0.7 -1.4 0.5 -1.1C1.7 -0.9 3.4 1 3 1.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(358 255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.2 0.1C-0.2 0.7 -1.1 1 -1.3 0.5C-1.4 0 -0.7 -1.2 -0.2 -1.3C0.3 -1.4 0.5 -0.5 0.2 0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(590 276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3 1.9C1.4 3 -2.1 3.1 -2.9 2.1C-3.8 1.2 -1.9 -0.9 -0.1 -1C1.6 -1.1 3.3 0.9 2.3 1.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190 345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7 1.2C1.2 1.8 -0.8 1.7 -1.3 1.1C-1.8 0.4 -0.9 -0.7 0.1 -0.7C1.1 -0.6 2.1 0.6 1.7 1.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(707 277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6 1.8C1.7 3 -1.8 3.1 -2.7 1.8C-3.5 0.6 -1.8 -1.9 0 -1.9C1.7 -1.9 3.5 0.6 2.6 1.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(783 213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.1 1.8C2.3 3.2 -1.3 3 -2.3 1.5C-3.3 0 -1.6 -2.9 0.2 -2.8C2 -2.7 3.9 0.4 3.1 1.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(454 577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9 0.7C1.5 1.8 -0.5 1.6 -1.1 0.4C-1.7 -0.9 -0.8 -3.2 0.2 -3.1C1.2 -3 2.3 -0.5 1.9 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(583 175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3 0.6C1.1 1.1 0 0.9 -0.3 0.3C-0.7 -0.3 -0.4 -1.1 0.2 -1C0.8 -0.9 1.5 0.2 1.3 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(151 87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3 1.9C2.1 4 -2.6 4.1 -3.8 2.1C-4.9 0 -2.5 -4.2 -0.1 -4.2C2.3 -4.3 4.5 -0.2 3.3 1.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(557 503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8 0.7C1.4 1.9 -0.8 1.8 -1.3 0.5C-1.9 -0.7 -1 -3.1 0.1 -3C1.2 -2.9 2.3 -0.5 1.8 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260 502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3 1.1C-0.8 2.1 -3.8 3 -4.2 2.4C-4.5 1.8 -2.3 -0.3 -0.8 -0.8C0.7 -1.2 1.4 0 0.3 1.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(550 138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6 1.9C1.5 3.5 -2.7 3.7 -3.6 2.2C-4.6 0.7 -2.3 -2.6 -0.2 -2.7C1.9 -2.8 3.8 0.2 2.6 1.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(889 416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2 0.5C0.5 2.1 -2.2 2.4 -2.7 1C-3.2 -0.4 -1.6 -3.6 -0.3 -3.7C1 -3.9 2 -1.1 1.2 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(799 354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7 0.5C0.6 0.6 0 0.5 -0.3 0.3C-0.5 0.1 -0.2 -0.3 0.1 -0.2C0.4 -0.2 0.9 0.3 0.7 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(491 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7 0.8C1.1 2.1 -1.3 2.1 -1.9 0.8C-2.5 -0.4 -1.2 -2.9 0 -3C1.2 -3 2.3 -0.5 1.7 0.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2 1C0.2 2.4 -2.8 2.9 -3.4 1.8C-3.9 0.7 -1.9 -1.9 -0.4 -2.1C1.1 -2.4 2.1 -0.3 1.2 1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(169 416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3 0.6C1.2 1 0.2 0.7 -0.2 0.2C-0.5 -0.3 -0.3 -1.1 0.2 -0.9C0.7 -0.8 1.4 0.2 1.3 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(772 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.3C0.4 0.4 -0.1 0.4 -0.2 0.2C-0.4 0 -0.2 -0.3 0 -0.3C0.3 -0.3 0.6 0.1 0.5 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(861 188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0.3C0.3 1.9 -2 2.2 -2.5 0.8C-2.9 -0.7 -1.5 -3.9 -0.3 -4.1C0.9 -4.2 1.8 -1.3 1 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8 1.7C3.4 2.9 0.5 2.1 -0.5 0.6C-1.6 -1 -0.8 -3.4 0.7 -3C2.1 -2.6 4.2 0.5 3.8 1.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(517 420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9 0.3C0.7 0.7 0 0.6 -0.2 0.1C-0.5 -0.4 -0.2 -1.2 0.1 -1.1C0.5 -1 1 -0.1 0.9 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(198 275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8 0.3C0.5 1 -0.8 1.1 -1 0.4C-1.3 -0.2 -0.7 -1.6 0 -1.6C0.6 -1.7 1.1 -0.3 0.8 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221 153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7 1.1C1 2.2 -1.6 2.3 -2.1 1.3C-2.7 0.3 -1.4 -1.7 -0.1 -1.7C1.2 -1.8 2.4 0.1 1.7 1.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(662 491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7 0.5C0.3 1.1 -1 1.2 -1.3 0.7C-1.6 0.2 -0.8 -0.9 -0.1 -1C0.6 -1.1 1.1 0 0.7 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75 63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4 0.7C1.2 1.2 -0.1 1 -0.5 0.3C-0.9 -0.3 -0.4 -1.4 0.2 -1.3C0.8 -1.2 1.6 0.1 1.4 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(821 393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2 1.2C0.4 2.1 -2.2 2.4 -2.7 1.7C-3.2 1 -1.6 -0.8 -0.3 -1C1 -1.2 2 0.3 1.2 1.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(852 295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7 0.4C0.4 0.8 -0.5 0.8 -0.7 0.4C-1 0.1 -0.5 -0.7 0 -0.7C0.5 -0.7 0.9 0 0.7 0.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(488 493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9 0.9C1.1 2.6 -2 2.8 -2.7 1.1C-3.4 -0.5 -1.7 -4 -0.2 -4.1C1.4 -4.2 2.8 -0.9 1.9 0.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8 1C1.2 2 -1.2 2 -1.8 1C-2.4 -0.1 -1.2 -2.2 0 -2.2C1.2 -2.2 2.4 -0.1 1.8 1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(535 565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8 0.5C-0.1 2 -2.7 2.6 -3.2 1.3C-3.6 0.1 -1.8 -3 -0.5 -3.2C0.8 -3.5 1.7 -1 0.8 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(313 451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.5C2.3 4.1 -2.4 4.1 -3.6 2.5C-4.7 0.9 -2.4 -2.3 0 -2.3C2.3 -2.3 4.7 0.9 3.5 2.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(203 468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8 1.4C0.9 2.7 -2.4 3 -3.1 1.8C-3.8 0.6 -1.9 -2.1 -0.3 -2.2C1.4 -2.4 2.8 0 1.8 1.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(307 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3 0.1C0 0.8 -1.1 1 -1.2 0.4C-1.4 -0.1 -0.7 -1.4 -0.2 -1.5C0.3 -1.6 0.7 -0.5 0.3 0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(783 557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6 0.7C-0.6 2.3 -3.7 3.1 -4.1 1.9C-4.5 0.7 -2.3 -2.6 -0.7 -3C0.9 -3.4 1.7 -1 0.6 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620 258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1.8C2.4 3.9 -2.1 3.9 -3.3 1.7C-4.4 -0.4 -2.2 -4.6 0 -4.6C2.3 -4.5 4.6 -0.3 3.5 1.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(599 55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.4 3.7C2.8 5.2 -3.2 5.3 -4.7 3.8C-6.2 2.4 -3.1 -0.6 -0.1 -0.6C3 -0.6 5.9 2.2 4.4 3.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71 154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7 2.6C1.4 3.8 -3.1 4.1 -4.1 3.1C-5.1 2 -2.6 -0.4 -0.3 -0.6C2 -0.7 4 1.4 2.7 2.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(755 197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9 0.2C0.5 1.1 -0.9 1.2 -1.2 0.3C-1.5 -0.7 -0.7 -2.6 -0.1 -2.6C0.6 -2.7 1.2 -0.8 0.9 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230 519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8 0.3C0.2 1.4 -1.6 1.7 -1.9 0.7C-2.2 -0.4 -1.1 -2.6 -0.2 -2.8C0.7 -2.9 1.4 -0.9 0.8 0.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(704 179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.2 1.3C0.8 3.8 -4 4.4 -4.9 2.2C-5.8 0 -2.9 -5.2 -0.5 -5.5C1.9 -5.8 3.7 -1.3 2.2 1.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341 442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.9 1.4C2.1 3 -1.3 2.8 -2.2 1.2C-3.1 -0.5 -1.5 -3.6 0.1 -3.6C1.8 -3.5 3.6 -0.2 2.9 1.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(472 372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9 0.6C-0.2 2.4 -3.3 3.1 -3.8 1.6C-4.3 0.2 -2.2 -3.4 -0.6 -3.7C1 -4 2 -1.2 0.9 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171 364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3 0.7C-0.8 2.1 -3.8 3 -4.1 2C-4.5 1 -2.2 -1.9 -0.8 -2.3C0.7 -2.8 1.4 -0.8 0.3 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(661 364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4 0.2C0.4 0.3 0.1 0.2 0 0.1C-0.2 0 -0.1 -0.2 0.1 -0.1C0.2 -0.1 0.5 0.2 0.4 0.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(660 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.1 2.1C1.9 4 -2.9 4.2 -4 2.4C-5.1 0.7 -2.5 -3.1 -0.2 -3.2C2.2 -3.3 4.4 0.3 3.1 2.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252 471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1 0.7C0.7 1.2 -0.7 1.2 -1 0.7C-1.4 0.1 -0.7 -1 0 -0.9C0.7 -0.9 1.4 0.1 1.1 0.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(394 62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.6C-0.3 1.7 -2.5 2.3 -2.9 1.4C-3.2 0.5 -1.6 -1.7 -0.5 -2C0.7 -2.3 1.4 -0.6 0.5 0.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.7 1.5C3.2 2.9 0.1 2.3 -0.9 0.5C-1.9 -1.2 -1 -4.1 0.6 -3.8C2.1 -3.5 4.1 0 3.7 1.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(761 129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.1 1.4C1.4 2.4 -1.4 2.4 -2.1 1.4C-2.8 0.4 -1.4 -1.6 0 -1.6C1.4 -1.6 2.8 0.4 2.1 1.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(606 311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3 0.1C0.2 0.2 -0.1 0.2 -0.2 0C-0.2 -0.2 -0.1 -0.6 0 -0.5C0.2 -0.5 0.3 -0.1 0.3 0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(681 396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4 0.5C0.9 1.7 -1 1.7 -1.5 0.6C-2 -0.6 -1 -2.9 0 -2.9C1 -2.9 1.9 -0.6 1.4 0.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(709 207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8 1.9C2.2 2.6 -0.7 2.3 -1.5 1.5C-2.4 0.6 -1.2 -0.8 0.3 -0.6C1.7 -0.5 3.4 1.2 2.8 1.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(829 331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8 1.1C1.5 1.6 -0.2 1.4 -0.8 0.7C-1.3 0 -0.7 -1.1 0.2 -0.9C1.1 -0.8 2.2 0.5 1.8 1.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(611 517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.2 1.1C1.3 2.7 -1.9 2.8 -2.6 1.2C-3.4 -0.4 -1.7 -3.7 -0.1 -3.7C1.5 -3.8 3 -0.6 2.2 1.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126 196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8 1.8C3.3 3 0.3 2.3 -0.8 0.8C-1.9 -0.8 -0.9 -3.3 0.6 -2.9C2.1 -2.6 4.3 0.6 3.8 1.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284 514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.1 0.1C-0.4 0.9 -1.7 1.4 -1.9 0.8C-2 0.2 -1 -1.5 -0.4 -1.7C0.3 -1.9 0.6 -0.7 0.1 0.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(353 30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6 0.4C0.4 0.7 -0.5 0.8 -0.7 0.4C-0.9 0.1 -0.5 -0.5 0 -0.6C0.4 -0.6 0.8 0.1 0.6 0.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(466 539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.2 0.1C0.1 0.3 -0.2 0.3 -0.3 0.1C-0.4 0 -0.2 -0.4 0 -0.4C0.1 -0.4 0.3 -0.1 0.2 0.1Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.5a8e8737acd83d59f5198cd2081a9cc0.svg";
export { ForwardRef as ReactComponent };